import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateFontDocument } from './create.generated';

export const useCreateFont = (options: ApiOptions<typeof CreateFontDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateFontDocument, {
    ...useNotifications(CreateFontDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.fonts.create_success'),
    }),
    ...options,
  });
};
